import React from 'react';
import { TableCell as MUITableCell, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type EmptyRowProps = {
  colSpan: number;
};

export const EmptyRow = ({ colSpan }: EmptyRowProps) => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <MUITableCell colSpan={colSpan}>
        <Typography variant="h4" align="center">
          {t('no data', { ns: 'common' })}
        </Typography>
      </MUITableCell>
    </TableRow>
  );
};
